// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73850b33","732":"d14b0a20","977":"2326a55a"}[chunkId] + ".chunk.js";
};